export default defineNuxtPlugin(nuxtApp=>{
 const client=useUser();let lastUser='',lastAttempt=0,inFlight=false;
 async function touch(){
  const actor=String(client.value?.client_id||'');
  if(!actor||document.visibilityState!=='visible'||inFlight)return;
  const now=Date.now();if(actor===lastUser&&now-lastAttempt<300000)return;
  lastUser=actor;lastAttempt=now;inFlight=true;
  try{await $fetch('/api/profiles/presence',{method:'POST'});}catch{lastAttempt=Date.now()-240000;}finally{inFlight=false;}
 }
 nuxtApp.hook('app:mounted',()=>{
  void touch();window.addEventListener('focus',touch);document.addEventListener('visibilitychange',touch);
  window.setInterval(touch,300000);
 });
 nuxtApp.hook('page:finish',()=>{void touch()});
 watch(()=>client.value?.client_id,()=>{void touch()});
});
